import axios from 'axios'
import { setCookie } from '~/js/cookies'
import { getCookieValue } from '~/js/helpers/cookie-helper'
const COOKIE_KEY_VOTER_ID = 'francfranc_voter_id'

/**
 * settings要素からAPIのベースURLとユーザーIDを取得する
 */
const getContestContext = () => {
  const elementSettings = document.getElementById('js-data')
  const baseUrl = elementSettings?.dataset.baseUrlFrontNamed || ''
  const userId = getCookieValue(COOKIE_KEY_VOTER_ID)
  return { baseUrl, userId }
}

/**
 * ユーザーが投票した記事のIDを取得する
 * @returns {Promise<{votedArticleId: string|null, userId: string|null}>}
 */
export const getVotedArticle = async () => {
  const { baseUrl, userId } = getContestContext()

  if (!userId) {
    const id = crypto.randomUUID()
    setCookie(COOKIE_KEY_VOTER_ID, id, { maxAge: 60 * 60 * 24 * 365 })
    return { votedArticleId: null, userId: id }
  }

  try {
    const { data } = await axios.get(`${baseUrl}/mrc_contest/get_user_vote`, {
      params: { uid: userId },
    })
    return { votedArticleId: data.articleId || null, userId }
  } catch (error) {
    console.error(error)
    return { votedArticleId: null, userId }
  }
}

/**
 * 記事に投票する
 * @param {string|number} articleId - 投票対象の記事ID
 * @returns {Promise<string|null>} 投票した記事ID
 */
export const vote = async (articleId) => {
  const { baseUrl, userId } = getContestContext()
  const { data } = await axios.post(`${baseUrl}/mrc_contest/vote`, {
    userId,
    articleId: articleId.toString().split('/').pop(),
  })
  return data.articleId || null
}
